<template>
    <div class="lease-units">
        <div class="lease-units__header">
            <h4 class="lease-units__title">Units</h4>
        </div>

        <div class="lease-units__content">
            <themed-table
                :columns="columns"
                :data="units"
                :pagination="true"
                :per-page-options="[5, 10, 25]"
                :searchable="false"
                :sortable="false"
                hoverable
            />
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import ThemedTable from '../ThemedTable.vue';

export default {
    name: 'LeaseUnits',

    components: {
        ThemedTable
    },

    props: {
        perPage: {
            type: Number,
            default: 10
        }
    },

    computed: {
        ...mapState(['leases', 'sites']),

        buildingUnitData() {
            return this.sites.selectedSite?.building?.units || [];
        },

        units() {
            return _.map(this.buildingUnitData, (unit) => {
                let isLeasedUnit = false;

                if (this.leases.selectedLease) {
                    isLeasedUnit = _.find(this.leases.selectedLease.units, ['id', unit.id]);
                }

                unit.leased_square_footage = isLeasedUnit
                    ? this.formatNumber(isLeasedUnit.pivot.leased_square_footage)
                    : '';
                unit.is_selected = !!isLeasedUnit;

                return unit;
            });
        },

        columns() {
            return [
                {
                    field: 'is_selected',
                    label: '',
                    width: '60px',
                    align: 'center',
                    formatter: (value, row) => {
                        const checked = value ? 'checked' : '';
                        return `<input 
                            type="checkbox" 
                            class="lease-units__checkbox" 
                            data-unit-id="${row.id}" 
                            ${checked}
                        />`;
                    }
                },
                {
                    field: 'floor',
                    label: 'Floor',
                    align: 'center'
                },
                {
                    field: 'suite',
                    label: 'Suite',
                    align: 'center'
                },
                {
                    field: 'size',
                    label: 'Size',
                    align: 'right',
                    formatter: (value) => this.formatNumber(value)
                },
                {
                    field: 'status',
                    label: 'Status',
                    align: 'right'
                },
                {
                    field: 'updated_at',
                    label: 'Last Update',
                    align: 'center',
                    formatter: (value) => this.formatDate(value)
                },
                {
                    field: 'leased_square_footage',
                    label: 'Leased Space',
                    formatter: (value, row) => {
                        return `<input 
                            type="text" 
                            class="lease-units__input" 
                            data-unit-id="${row.id}"
                            value="${value || ''}"
                            min="0"
                            max="${row.size}"
                        />`;
                    }
                }
            ];
        }
    },

    mounted() {
        // Handle checkbox clicks
        this.$el.addEventListener('change', (e) => {
            if (e.target.classList.contains('lease-units__checkbox')) {
                const unitId = parseInt(e.target.dataset.unitId);
                this.toggleUnit(e.target.checked, unitId);
            }
        });

        // Handle input changes
        this.$el.addEventListener('input', (e) => {
            if (e.target.classList.contains('lease-units__input')) {
                const unitId = parseInt(e.target.dataset.unitId);
                this.updateLeasedSquareFootage(e.target.value, unitId);
            }
        });
    },

    methods: {
        isInLease(unitId) {
            if (this.leases.selectedLease) {
                return _.find(this.leases.selectedLease.units, ['id', unitId]);
            }
            return false;
        },

        toggleUnit(checked, unitId) {
            let unit = _.find(this.units, ['id', unitId]);

            if (unit && checked) {
                unit.pivot = { leased_square_footage: unit.size };
                unit.leased_square_footage = unit.size;
                this.leases.selectedLease.units.push(unit);
            } else if (unit && !checked) {
                unit.pivot = { leased_square_footage: '' };
                unit.leased_square_footage = '';
                this.leases.selectedLease.units = _.remove(this.leases.selectedLease.units, (u) => {
                    return u.id !== unitId;
                });
            }

            this.$forceUpdate();
        },

        updateLeasedSquareFootage(value, unitId) {
            let unit = _.find(this.leases.selectedLease.units, ['id', unitId]);
            if (unit) {
                unit.pivot = { leased_square_footage: value };
                unit.leased_square_footage = value;
            }

            let displayUnit = _.find(this.units, ['id', unitId]);
            if (displayUnit) {
                displayUnit.leased_square_footage = value;
            }
        },

        formatNumber(value) {
            if (value === null || value === undefined) return '';
            return new Intl.NumberFormat('en-US').format(value);
        },

        formatDate(date) {
            if (!date) return '';
            return new Date(date).toLocaleDateString('en-US', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit'
            });
        }
    }
};
</script>
